import { render, staticRenderFns } from "./BidSuggestion.vue?vue&type=template&id=56d4939c&scoped=true"
import script from "./BidSuggestion.vue?vue&type=script&lang=js"
export * from "./BidSuggestion.vue?vue&type=script&lang=js"
import style0 from "./BidSuggestion.vue?vue&type=style&index=0&id=56d4939c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d4939c",
  null
  
)

export default component.exports